// Configuration for app redirect URLs
export const REDIRECT_CONFIG = {
  // Replace these URLs with your actual app store URLs
  ANDROID_URL: "https://play.google.com/store/apps/details?id=dev.expo.notificationsapptutlogistics",
  IOS_URL: "https://apps.apple.com/in/app/instaship/id6747907836",
  FALLBACK_URL: "/", // Where to redirect desktop users or if detection fails
  
  // Tracking Portal URL
  TRACKING_PORTAL_URL: "/trackingPortal",
  
  // Optional: Add delay before redirect (in milliseconds)
  REDIRECT_DELAY: 1500,
  
  // Optional: Enable console logging for debugging
  DEBUG_MODE: true,
};

// Helper function to log platform detection (for debugging)
export const logPlatformDetection = (platform: string, userAgent: string) => {
  if (REDIRECT_CONFIG.DEBUG_MODE) {
    console.log(`Platform detected: ${platform}`);
    console.log(`User Agent: ${userAgent}`);
  }
};